/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Users = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M3 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm14 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1 1h-2c-.6 0-1 .2-1.4.6 1.3.7 2.2 1.9 2.3 3.4H19c.6 0 1-.4 1-1v-1c0-1.1-.9-2-2-2zm-8 0c1.9 0 3.5-1.6 3.5-3.5S11.9 3 10 3 6.5 4.6 6.5 6.5 8.1 10 10 10zm2.4 1h-.3c-.6.3-1.4.5-2.1.5s-1.5-.2-2.1-.5h-.3c-2 0-3.6 1.6-3.6 3.6v.9c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-.9c0-2-1.6-3.6-3.6-3.6zm-7-.4C5 10.2 4.6 10 4 10H2c-1.1 0-2 .9-2 2v1c0 .6.4 1 1 1h2.1c.2-1.5 1.1-2.7 2.3-3.4z" />
  </svg>
);

export default extendIcon(Users);
